import L from 'leaflet';

import React from 'react';

import { JsonToTable } from "react-json-to-table";

import { renderToString } from 'react-dom/server'

//image exif orientation change: find . -type f -name "*.jpg" -exec exiftran -ai "{}" \; #semicolon is a must

var utils={};
utils.hstore2object = function(hstore) {
    if (!hstore) return hstore;
    hstore = hstore.substring(1, hstore.length-1);
    let r = hstore.split('", "');
    return r.reduce((acc,cval) => {
        let a = cval.split('"=>"');
        if (a.length===2) {
            acc[a[0]] = a[1];
        }
        return acc;
    }, {});
}

utils.getQueryParameter = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}

var mapUtils = {};

function onEachFeature(feature, layer, layerCodeListKey, map) {
    // does this feature have a property named popupContent?
    let popup = null;
    if (feature.properties) {
        let slika = '';
        if (feature.properties.IME_SLIKE !== undefined) {
            const imeSlike = feature.properties.IME_SLIKE.toLowerCase();
            if (feature.properties.IME_SLIKE !== '') slika = `<img style="max-height:200px;max-width:310px" src="./images/${imeSlike}" />`;
            delete feature.properties.IME_SLIKE;
        }
        
        if (feature.properties.POVEZAVA_SODISCA !== undefined) {
            delete feature.properties.POVEZAVA_SODISCA;
        }

        if (layerCodeListKey === 'DOSTOPNOST_JAVNEGA_OBJEKTA') {
            !feature.properties['SIFKO'] && delete feature.properties['SIFKO'];
            !feature.properties['ID STAVBE'] && delete feature.properties['ID STAVBE'];
        }

        delete feature.properties.record_id;

        popup = `<div style="display: flex; align-items: center; max-height: 200px">
                    <div style="width:310px;margin-right:5px; max-height: 200px; overflow-y:auto">
                        ${renderToString(<JsonToTable json={feature.properties} />)}
                    </div>
                    <div style="width:${slika ? 310 : 0}px; height:100%; max-height:200px; margin-left:5px">
                        ${slika}
                    </div>
                </div>`;

        console.log(layerCodeListKey)

        if (layerCodeListKey === 'DOSTOPNOST_JAVNEGA_OBJEKTA' || layerCodeListKey === 'NEDOSTOPNOST_JAVNEGA_OBJEKTA') {
            
            const sifko = feature.properties['SIFKO'];
            const idsta = feature.properties['ID STAVBE'];

            if (sifko && idsta) {
                popup = popup + `<br><a target="_blank" href="http://dostopnost.javniobjekti.si/prikaz?i_ko=${sifko}&i_obj=${idsta}">Povezava na dostopnost javnih objektov</a>`;
            }
        }

        layer.bindPopup(popup, {maxWidth : 640});
    }

    if (layerCodeListKey === 'ZVOCNI_SEMAFORJI') {
        const c = feature.geometry.coordinates[0];
        c.map((vertex) => {
            let circle = L.circle([vertex[1], vertex[0]], {
                stroke: false,
                fillColor: layer.options.style.color,
                fillOpacity: 1.0,
                radius: 2
            }).addTo(map);
            
            if (popup !== null) {
                circle.bindPopup(popup);
            }
        });
    }       
}

/* https://gist.github.com/geog4046instructor/80ee78db60862ede74eacba220809b64
 * Create a custom icon to use with a GeoJSON layer instead of the default blue
 * marker. This snippet assumes the map object (map) and GeoJSON object
 * (myLayerData) have already been declared.
 */

// replace Leaflet's default blue marker with a custom icon
function createCustomIcon (feature, latlng, iconImg) {
    let myIcon = L.icon({
      iconUrl: './icons/'+iconImg,
      popupAnchor:  [11, 11]
      //shadowUrl: 'my-icon.png',
      /*iconSize:     [25, 25], // width and height of the image in pixels
      shadowSize:   [35, 20], // width, height of optional shadow image
      iconAnchor:   [12, 12], // point of the icon which will correspond to marker's location
      shadowAnchor: [12, 6],  // anchor point of the shadow. should be offset
      popupAnchor:  [0, 0] // point from which the popup should open relative to the iconAnchor*/
    })
    return L.marker(latlng, { icon: myIcon })
  }

mapUtils.add = (map, geomData, attributeData, iconImg, codeList, lineColor, layerCodeListKey, lineWidth, dashArray, opacity) => {
    let features = [];

    let attributes = [];

    for ( const key in attributeData) {
        let feature = {"type": "Feature"};
        feature.properties = Object.values(attributeData[key]).filter((f) => f.field !== 'ranljiva_skupina').filter(f => {
            if (f.field === 'osm_name') {
                return true;
            }
            
            return !f.field.startsWith('osm_');
        }).filter(f=>{
            return codeList[[f.field.toUpperCase()]] !== undefined;
        }).map( (f) => {
            if (!f.value || f.value === 'None' || f.value === 'NULL') f.value = '';
            return { [codeList[[f.field.toUpperCase()]].trans] : codeList[[f.value]] ? codeList[[f.value]].trans : f.value };
        });
        feature.properties = Object.assign({record_id: key}, ...feature.properties);
        attributes.push(feature.properties);
        feature.geometry = JSON.parse(geomData[key].value.value);
        features.push(feature);
    }

    let options = {
        pointToLayer: (feature, latlng) => createCustomIcon(feature, latlng, iconImg),
        filter: function(feature, layer) {
            return true;
        },
        onEachFeature: (feature, layer) => onEachFeature(feature, layer, layerCodeListKey, map)
    };

    options.style = {};

    if (lineColor) {
        options.style.color = lineColor;
    }

    if (lineWidth) {
        options.style.weight = lineWidth;
    }

    if (dashArray) {
        options.style.dashArray = dashArray;
    }

    if (opacity) {
        options.style.opacity = opacity;
    }

    let layer = L.geoJSON(features, options);

    layer.addTo(map);

    layer.attributes = attributes;

    return layer;

    /*
    
    var vals = Object.values(data).map((rec)=>JSON.parse(rec.value.value))
    console.log(vals)
    
    */
}

export default utils;
export var mapUtils=mapUtils;
